// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"jgp-2tylP"};